export default __webpack_public_path__ + "static/media/misc-books3-768w.dc5d00ba.webp";